export const SET_DOCUMENT = 'SET_DOCUMENT';
export const UPDATE_DOCUMENT = 'UPDATE_DOCUMENT';

export const SET_PERMISSIONS = 'SET_PERMISSIONS';

export const SET_DOCUMENT_WITH_PERMISSIONS = 'SET_PERMISSIONS';
